<div style="padding: 0.5em;">
    <mat-card-header>
        <mat-card-title style="font-size: large">Validate Application Details</mat-card-title>
    </mat-card-header>
    <mat-dialog-content>
        <form [formGroup]="form">
            <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <!-- <button mat-button (click)="populateDemo(1)">Demo 1</button> -->
        <button mat-raised-button (click)="submitApplication()">Pull Credit</button>
        <button mat-button (click)="onDismiss()">Dismiss</button>
    </mat-dialog-actions>
</div>